import styled, { css } from 'styled-components';

export const Container = styled.div`
    ${({ theme }) => css`
        color: ${theme.colors.campaigns.clearing.primary.hex};
        display: flex;
        justify-content: center;
        text-align: center;
        flex-direction: column;
    `}
`;

export const Heading = styled.h2`
    ${({ theme }) => css`
        display: flex;
        align-items: center;
        flex-direction: column;
        font-family: ${theme.fonts.secondary};
        font-size: 4rem;
        font-weight: bold;
        color: inherit;
        text-align: inherit;
        line-height: 1.1;
        margin: 0;

        @media ${theme.breakpoints.large.media} {
            font-size: 5.5rem;
        }
    `}
`;

export const Span = styled.span`
    ${({ theme }) => css`
        font-family: ${theme.fonts.primary};
        font-size: 1.375rem;
        max-width: 23.125rem;

        @media ${theme.breakpoints.large.media} {
            font-size: 1.75rem;
        }
    `}
`;

export const Text = styled.span`
    ${({ theme }) => css`
        margin-top: 0.5rem;
        color: ${theme.colors.campaigns.clearing.secondary.hex};
    `}
`;
